import React, { useRef } from 'react';
import ReactECharts from 'echarts-for-react';
import { chartColours } from '../../theme/constants';

const DevicesChart = ({ data, label, showLegend = true, colours = null, chartHeight = 300 }) => {
    const ref = useRef(null);

    const noData = !data?.find(e => e.value > 0);

    const legend = (showLegend && !noData) ? {
        top: 0,
        left: 'center'
    } : {
        show: false
    };

    const options = {
        tooltip: {
            trigger: 'item',
            formatter: params => {
                if (params.data.percentage) {
                    return `${params.marker}${params.name}: <b>${new Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 }).format(params.data.percentage) + '%'}</b> (${new Intl.NumberFormat('en-GB', { maximumFractionDigits: 0 }).format(params.value)})`;
                }

                return `${params.marker}${params.name}: <b>${new Intl.NumberFormat('en-GB', { maximumFractionDigits: 0 }).format(params.value)}</b>`;
            }
        },
        legend,
        series: [
            {
                name: label,
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: 'center'
                },
                labelLine: {
                    show: false
                },
                data: noData ? [] : data,
                color: colours ?? [chartColours[0].value, chartColours[1].value, chartColours[2].value]
            }
        ]
    };

    return (
        <ReactECharts
            option={options}
            style={{ height: chartHeight }}
            opts={{ renderer: 'svg' }}
            ref={ref}
        />
    );
};

export default DevicesChart;